import * as React from 'react';
import {Field, InjectedFormProps, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {DatePickerRangeField, RenderField, Validators} from './Fields/_Fields';
import {withTranslation} from 'react-i18next';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {compose} from 'redux';
import {Dropdown} from "components/Layout/Dropdown/Dropdown.Component";
import * as VehicleActions from "Redux/Actions/VehicleActions";

type ConnectedProps = {
  viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
  t: Function;
  downloadTraceHistoryToXLSX: () => void
};

const SearchRidesForm = (props: InjectedFormProps & ConnectedProps) => {
  const {
    handleSubmit,
    submitting,
    t,
    downloadTraceHistoryToXLSX
  } = props;

  const options = React.useMemo(() => [
    {
      content: t('forms:GET_TRACE_AS_EXCEL'),
      id: "GET_TRACE_AS_EXCEL",
      onClick: downloadTraceHistoryToXLSX
    }
  ], [downloadTraceHistoryToXLSX])

  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="dateRange"
        component={DatePickerRangeField}
        type="text"
        placeholder={t('dateRange')}
        label={t('dateRange')}
        validate={[Validators.required, Validators.dateRangeIsCorect]}
        endDateLabel={t('endDate')}
        startDateLabel={t('startDate')}
        dateRangePlaceholder={t('dateRangeSelect')}
        additionalComponent={<Dropdown
          id="get-trace-menu"
          label={t('GET_TRACE_AS')}
          options={options}
        />}
        wrapperClassName="search-rides-date-picker"
      />
      <div className="search-rides__km-and-generate-button">
        <Field name="ignoreShorterThanKilometers" component={RenderField} type="text" placeholder={t('writeKm')}
               label={t('ignoreShorterThanKilometers')}/>
        <button disabled={submitting} className="btn btn--blue" type="submit">
          {t('generate')}
        </button>
      </div>
    </form>
  );
};

function mapStateToProps(state: any) {
  return {
    viewManagementStore: state.viewManagementStore
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    downloadTraceHistoryToXLSX: () => dispatch(VehicleActions.downloadTraceHistoryToXLSX())
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(['forms', 'errors']),
  reduxForm({
    form: 'searchRidesForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })
)(SearchRidesForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/SearchRidesForm.tsx